import { useDebateContext } from "contexts/DebateContext";
import { useEffect, useState } from "react";
import { TYPO } from "styles/Typo";
import DiscussLikeButton from "./Button/LikeButton";
import DiscussCommentButton from "./Button/CommentButton";
import DiscussShareButton from "./Button/ShareButton";
declare global {
  interface Window {
    Kakao: any;
  }
}

const ShareButtonContainer = ({ children }: { children: React.ReactNode }) => {
  return (
    <div
      className=" bg-white rounded-[56px] flex items-center gap-4 px-6 py-2 border border-gray15"
      style={{
        boxShadow: "0px 2px 16px 0px rgba(0, 0, 0, 0.25)",
        WebkitBoxShadow: "0px 2px 16px 0px rgba(0, 0, 0, 0.25)",
      }}
    >
      {children}
    </div>
  );
};

const VoteButton = ({ data, submitVote }: { data: any; submitVote: any }) => {
  const OOption = data?.options?.find((option: any) => option.symbol === "O");
  const XOption = data?.options?.find((option: any) => option.symbol === "X");
  const goVoteSection = () => {
    const voteSection = document.getElementById("vote-section");
    if (voteSection) {
      voteSection.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };
  return (
    <>
      <p className={`${TYPO.TYPO7_1_SB} text-gray80 text-center`}>
        {data?.title}
      </p>
      <div className="w-full flex gap-2 items-stretch">
        <div
          className="grow bg-blue10 rounded-[12px] p-2 text-center cursor-pointer flex-1 flex items-center justify-center"
          onClick={() => {
            submitVote(OOption?.value, OOption?.symbol);
            goVoteSection();
          }}
          data-gtm-id={`report-floating-vote-button`}
        >
          <p className={`${TYPO.TYPO7_1_MD} text-blue50`}>{OOption?.value}</p>
        </div>
        <div
          className="grow bg-red10 rounded-[12px] p-2 text-center cursor-pointer flex-1 flex items-center justify-center"
          onClick={() => {
            submitVote(XOption?.value, XOption?.symbol);
            goVoteSection();
          }}
          data-gtm-id={`report-floating-vote-button`}
        >
          <p className={`${TYPO.TYPO7_1_MD} text-red50`}>{XOption?.value}</p>
        </div>
      </div>
    </>
  );
};

const VoteButtonContainer = ({ children }: { children: React.ReactNode }) => {
  return (
    <div
      className="flex flex-col bg-white p-[10px] border border-gray15 w-[335px] rounded-[16px] items-center justify-center gap-2"
      style={{
        boxShadow: "0px 2px 16px 0px rgba(0, 0, 0, 0.25)",
        WebkitBoxShadow: "0px 2px 16px 0px rgba(0, 0, 0, 0.25)",
      }}
    >
      {children}
    </div>
  );
};
function FloatingButton({
  status,
  data,
  submitVote,
}: {
  status: "SHARE" | "VOTE";
  data: any;
  submitVote: any;
}) {
  const [isAnimating, setIsAnimating] = useState(false);
  const [currentStatus, setCurrentStatus] = useState(status);
  const [animationClass, setAnimationClass] = useState("float-in");

  useEffect(() => {
    if (status !== currentStatus) {
      setIsAnimating(true);
      setAnimationClass("float-out");

      // 애니메이션이 끝난 후 상태 변경
      const timer = setTimeout(() => {
        setCurrentStatus(status);
        setAnimationClass("float-in");
        setIsAnimating(false);
      }, 500); // float-out 애니메이션 시간과 동일하게 설정

      return () => clearTimeout(timer);
    }
  }, [status]);

  if (!status) return null;
  return (
    <div className="fixed bottom-[25px] left-[50%] translate-x-[-50%] z-[5]">
      {currentStatus === "SHARE" ? (
        <div className={animationClass}>
          <ShareButtonContainer>
            <DiscussLikeButton data={data} from="floating" />
            <DiscussCommentButton from="floating" />
            <DiscussShareButton data={data} from="floating" />
          </ShareButtonContainer>
        </div>
      ) : (
        <div className={animationClass}>
          <VoteButtonContainer>
            <VoteButton data={data} submitVote={submitVote} />
          </VoteButtonContainer>
        </div>
      )}
    </div>
  );
}

export default FloatingButton;
